import { render, staticRenderFns } from "./resumenine_template.vue?vue&type=template&id=368c88b0&"
import script from "./resumenine_template.vue?vue&type=script&lang=js&"
export * from "./resumenine_template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports